<template>
  <div>
      <div container>
        <div grid="row wrap"  column="12">
          <div v-html="group_title_header_html"></div>
        </div>
          <div class="card" column="12"><br>
            <p><span class="lips validation">* Validation Required: </span><b><i>Before proceeding, please validate the information below for accuracy.
              If the effective date, state, legal name etc. are incorrect please reach out to your
              <a :href="internalValue.mailTo">business coordinator</a>.</i></b>
            </p>
            <div grid="row wrap">
              <div class="_mtxs" column="3">
                <app-labeled-data
                  :data="internalValue.contactEffectiveDate"
                  label="Contract Effective Date:"
                />
              </div>
              <div class="_mtxs" column="3">
                <app-labeled-data
                  :data="internalValue.businessState.text"
                  label="Business State:"
                />
              </div>
              <div class="_mtxs" column="6">
                <app-input
                  :disabled='false'
                  :errorMessage="companyNameError"
                  :invalid="$v.internalValue.companyName.$invalid"
                  :required="true"
                  label='Company Name:'
                  v-model="$v.internalValue.companyName.$model"
                  valueKey='companyName'
                  @input="[escapeGroupName(),saveGroupTitleInformation()]"
                />
              </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>

  import AppLabeledData from '@molecules/LabeledData'
  import AppInput from '@atoms/Input'
  import { maxLength, requiredIf } from 'vuelidate/lib/validators'
  import { escapeGroupName } from '@/utils'
  import clientOnboardVerbiage from '@mixins/clientOnboardVerbiage'

  export default {
    mixins: [
      clientOnboardVerbiage
    ],
    components: {
      AppLabeledData,
      AppInput
    },
    props: {
      value: {
        type: Object
      }
    },
    data() {
      return {
        isLastSigner: this.value.isLastSigner,
        internalValue: {
          companyName: this.value.companyName,
          contactEffectiveDate: this.value.contactEffectiveDate,
          businessState: this.value.businessState || '',
          mailTo: 'mailTo:' + this.value.mailTo
        }
      }
    },
    methods: {
      escapeGroupName() {
        this.internalValue.companyName = escapeGroupName(this.internalValue.companyName)
      },
      isFormValid() {
        this.$v.$touch()
        return !this.$v.$error
      },
      saveGroupTitleInformation() {
        if (this.isFormValid()) {
          this.$emit('groupTitleInfoUpdated', this.internalValue)
        }
      }
    },
    validations: {
      internalValue: {
        companyName: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(200)
        }
      }
    },
    computed: {
      companyNameError() {
        if (!this.$v.internalValue.companyName.required) {
          this.$emit('titleSectionHasError', true)
          return 'required'
        } else if (!this.$v.internalValue.companyName.maxLength) {
          this.$emit('titleSectionHasError', true)
          return 'character limit exceeded'
        } else if (this.$v.internalValue.companyName.required || this.$v.internalValue.companyName.maxLength) {
          this.$emit('titleSectionHasError', false)
        }
        return null
      }
    },
    watch: {
      internalValue: {
        deep: true,
        handler() {
          this.$emit('valueChanged', true)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  span.lips {
    color: $color-lips;
  }

  span.bold {
    font-weight: bold;
    font-style: italic;
  }
</style>
